import axios from '../axios'

/*
 * 用户协议
 */

export const selectByPage = (data) => {
    return axios({
        url: '/protocol/selectByPage',
        method: 'post',
        data
    })
}
export const insertProtocol = (data) => {
    return axios({
        url: '/protocol/insert',
        method: 'post',
        data
    })
}

export const deleteProtocol = (data) => {
    return axios({
        url: '/protocol/batchDelete',
        method: 'post',
        data
    })
}

export const updateProtocol = (data) => {
    return axios({
        url: '/protocol/update',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/userAgreement/index.js